import React, { useEffect, useState } from 'react';
import api from "../../services/api.js";
import { useNavigate } from 'react-router-dom';
import logobody from '../../images/Nortesoft.png';

import './login.css';

const emptyCompany = {
    cdemp: '',
    deemp: '',
    ativoemp: '',
    apelido: '',
    Cidemp: '',
    Estemp: '',
    Baiemp: '',
    TipoEmp: '',
};

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [empresas, setEmpresas] = useState([]);
    const navigate = useNavigate();
    const [buttonText, setButtonText] = useState('Login');
    const [empresaescohida, setEmpresaEscolhida] = useState(emptyCompany);

    const carregarEmpresas = async () => {
        const resp = await api.get(`/t_emp/user/${email}`, {
            params: {
                user: email,
            }
        });

        const modifiedData = {
            total_registros: resp.data.count,
            dados: resp.data.rows
        };

        if (modifiedData.total_registros > 0) {
            setEmpresas(modifiedData.dados);
            setEmpresaEscolhida(modifiedData.dados[0]);
            setButtonText('Acessar');
            return;
        }

        setEmpresas([]);
        alert("Nenhuma unidade encontrada para este usuario.");
    };

    const concluirAutenticacao = async (authData) => {
        const jwtToken = authData?.token;

        if (!jwtToken) {
            throw new Error("Token nao recebido.");
        }

        localStorage.setItem('token', jwtToken);
        localStorage.setItem('user', email.trim());

        await carregarEmpresas();
    };

    const autenticarUsuario = async () => {
        const loginResponse = await api.post(`/auth/login`, {
            login: email,
            senha: password
        });

        if (loginResponse.data?.status === 'two_factor_required') {
            const message = loginResponse.data.twoFactorMethod === 'authenticator'
                ? 'Informe o codigo atual do Google Authenticator:'
                : 'Informe o codigo enviado para o seu email:';

            const code = window.prompt(message, '');

            if (!code || !code.trim()) {
                throw new Error('Codigo de autenticacao nao informado.');
            }

            const confirmResponse = await api.post(`/auth/login/2fa`, {
                challengeId: loginResponse.data.challengeId,
                code: code.trim()
            });

            return confirmResponse.data;
        }

        return loginResponse.data;
    };

    const acessarEmpresaSelecionada = async () => {
        if (!empresaescohida.cdemp) {
            alert("Selecione uma unidade.");
            return;
        }

        const resp = await api.get(`/t_emp/${empresaescohida.cdemp}`, {
            params: {
                user: email,
            }
        });

        const empresaCompleta = resp.data || {};

        localStorage.setItem("cdemp", String(empresaCompleta.cdemp || empresaescohida.cdemp));
        localStorage.setItem("cidemp", (empresaCompleta.Cidemp || empresaCompleta.cidemp || '').trim());
        localStorage.setItem("estemp", (empresaCompleta.Estemp || empresaCompleta.estemp || '').trim());
        localStorage.setItem("baiemp", (empresaCompleta.Baiemp || empresaCompleta.baiemp || '').trim());
        localStorage.setItem("tipoemp", (empresaCompleta.TipoEmp || empresaCompleta.tipoemp || '').trim());
        localStorage.setItem("user", email.trim());

        navigate("/dashboard");
    };

    const handleLogin = async () => {
        try {
            if (buttonText === 'Login') {
                const authData = await autenticarUsuario();
                await concluirAutenticacao(authData);
                return;
            }

            await acessarEmpresaSelecionada();
        } catch (err) {
            const message = err?.response?.data?.message || err?.message || "Falha ao autenticar.";
            alert(Array.isArray(message) ? message.join('\n') : message);
        }
    };

    const containerStyle = {
        backgroundColor: '#f7f7f7'
    };

    const handleCancel = () => {
        setEmail('');
        setPassword('');
        navigate("/");
    };

    const handleSelectEmpChange = (e) => {
        const selectedCdemp = Number(e.target.value);
        const selectedEmpresa = empresas.find(emp => emp.cdemp === selectedCdemp);
        setEmpresaEscolhida(selectedEmpresa || emptyCompany);
    };

    useEffect(() => {
        localStorage.setItem("user", email.trim());
    }, [email]);

    return (
        <div className='container'>
            <div className="login-container" style={containerStyle}>
                <div className='container'>
                    <img src={logobody} alt="logobody" className="logobody" />
                </div>

                <div className="login-form">
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <div className='col-xl-12 col-md-12 col-sm-12 mt-0'>
                        <small className="text-secondary">Unidade</small>
                        <select
                            name="unidade"
                            className="form-control mt-1 mb-3"
                            value={empresaescohida.cdemp}
                            onChange={handleSelectEmpChange}
                            disabled={buttonText !== 'Acessar'}
                        >
                            {empresas.map((item) => (
                                <option key={item.cdemp} value={item.cdemp}>
                                    {item.apelido || item.fantemp || item.deemp}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="buttons">
                        <button className="btn btn-secondary" onClick={handleCancel}>Voltar</button>
                        <button className="btn btn-primary" onClick={handleLogin}>{buttonText}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
